import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './MobileSideMenu.style.css';

const MobileSideMenu = ({
  setIsOpen,
  isLogin = false,
  name = '',
  onLogout,
}) => {
  const navigate = useNavigate(); // React Router 네비게이션 훅
  const location = useLocation(); // 현재 경로를 가져옴

  const menuItems = [
    //{ title: '마이페이지', path: '/mypage/home' },
    { title: '주문/배송조회', path: '/mypage/order' },
    { title: '취소/교환/반품 내역', path: '/mypage/cancel' },
    { title: '정기배송 설정 관리', path: '/mypage/subscribe' },
    {
      title: '회원 등급',
      path: '/cs/notice/hZsTD8bG3Kn2XCUKxyL1Ow%3D%3D',
    },
    { title: '포인트', path: '/mypage/point' },
    { title: '쿠폰', path: '/mypage/coupon' },
    { title: '위시리스트', path: '/mypage/wishlist/wishlist' },
    { title: '상품 리뷰', path: '/mypage/review' },
    { title: '상품 문의', path: '/mypage/qna' },
    { title: '선물내역', path: '/mypage/presents' },
    { title: '회원 정보 수정', path: '/mypage/editprofile' },
    { title: 'JM Pay 관리', path: '/mypage/pay' },
    { title: '배송지 관리', path: '/mypage/address' },
    { title: 'FAQ', path: '/cs/faq' },
    { title: '공지사항', path: '/cs/notice' },
    { title: '1:1 문의', path: '/cs/inquire' },
  ];

  return (
    <div className={`mobile-menu`}>
      <div className="inner">
        <ul>
          {!isLogin ? (
            <React.Fragment>
              <li
                onClick={() => {
                  navigate('/signin');
                  setIsOpen(false);
                }}
              >
                로그인
              </li>
              <li
                onClick={() => {
                  navigate('/signup');
                  setIsOpen(false);
                }}
              >
                회원가입
              </li>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <li
                onClick={() => {
                  navigate('/mypage/home');
                  setIsOpen(false);
                }}
              >
                {name} 님
              </li>
              <li
                onClick={() => {
                  onLogout();
                  setTimeout(() => setIsOpen(false), 0);
                }}
              >
                로그아웃
              </li>
            </React.Fragment>
          )}
          {menuItems.map((item, index) => (
            <li
              key={`top_menu_${index}`}
              className={
                location.pathname === item.path ? 'active-menu-item' : ''
              }
              onClick={() => {
                navigate(item.path); // 페이지 이동
                setIsOpen(false);
              }}
            >
              {item.title}
            </li>
          ))}
          <li
            target="_blank"
            onClick={() =>
              window.open('https://jmcoffee.co.kr/contact/inquire/')
            }
          >
            B2B PARTNERS
          </li>
        </ul>
      </div>
    </div>
  );
};

export default MobileSideMenu;
